import translate from '../../translations'

export default data => {
  let str = `
        <div class="card__visual">
          <img src="${data.imgSrc}" alt="">
        </div>
        <div class="card__inner">
          <div class="card__content">
            <a href="${data.url}">
              <h2 class="card__title">${data.title}</h2>
            </a>
            <div class="card__text">
                ${data.desc}
            </div>`
  if (data.fileURL) {
    str += `<a target="_blank" href="${
      data.fileURL
    }" class="button button-icon button--white mt-20" rel="nofollow">
                <div>
                    <svg class="icon icon-arrow-corner-down icon--red" aria-hidden="true">
                        <use href="#icon-arrow-corner-down" xlink:href="#icon-arrow-corner-down"></use>
                    </svg>
                    <span>${translate('DOWNLOAD')}</span>
                </div>
            </a>`
  } else {
    str += `<a target="_self" href="${
      data.url
    }" class="button button-icon button--white mt-20" rel="nofollow">
                  <div>
                      <svg class="icon icon-arrow-corner-down icon--red" aria-hidden="true">
                          <use href="#icon-arrow-corner-down" xlink:href="#icon-arrow-corner-down"></use>
                      </svg>
                      <span>${translate('CONSULT')}</span>
                  </div>
              </a>`
  }

  str += `</div>
        </div>`

  return str
}
